import { useEffect, useState } from 'react'

type ColorMode = 'light' | 'dark'

const STORAGE_KEY = 'mangaos-color-mode'

function getInitialColorMode(): ColorMode {
  if (typeof window === 'undefined') return 'light'

  const saved = window.localStorage.getItem(STORAGE_KEY)
  if (saved === 'light' || saved === 'dark') return saved

  // 初回だけOS設定を尊重。以後はlocalStorage優先。
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export default function ColorModeToggleButton({
  mobile = false,
}: {
  mobile?: boolean
}) {
  const [mode, setMode] = useState<ColorMode>(getInitialColorMode)

  useEffect(() => {
    const root = document.documentElement
    // テーマ切替の瞬間だけ全要素の transition を止める。
    // var() 由来の色に transition が掛かっていると、Light→Dark 直後に旧色のまま残ることがあるため、
    // 切替を同期的に反映し、強制リフローで確定させてから解除する。
    root.dataset.colorSwitching = ''
    root.dataset.colorMode = mode
    root.style.colorScheme = mode
    void root.offsetHeight
    delete root.dataset.colorSwitching
    window.localStorage.setItem(STORAGE_KEY, mode)
    window.dispatchEvent(new CustomEvent('mangaos-color-mode-change', { detail: { mode } }))
  }, [mode])

  const isDark = mode === 'dark'

  return (
    <button
      type="button"
      className={mobile ? 'mobile-drawer-color-mode-btn' : 'btn btn-outline btn-sm color-mode-toggle-btn'}
      aria-pressed={isDark}
      title={isDark ? 'ライトモードに切り替えます' : 'ダークモードに切り替えます'}
      onClick={() => setMode((current) => (current === 'dark' ? 'light' : 'dark'))}
    >
      <span aria-hidden="true">{isDark ? '☀' : '☾'}</span>
      {isDark ? 'Light' : 'Dark'}
    </button>
  )
}
